import { apiCall } from './config';

export default {
  getLeadsApi: payload =>
    apiCall('v1/partnerportal/sfdc/leads', 'GET', {
      queryString: payload
    }),
  createLead: payload => {
    return apiCall('v1/partnerportal/sfdc/lead', 'POST', {
      body: payload
    });
  },
  checkLead: payload =>
    apiCall('v1/partnerportal/sfdc/leads/exists', 'POST', {
      body: { ...payload }
    }),

  updateLeadStatus: payload => {
    return apiCall('v1/partnerportal/sfdc/leads', 'PATCH', {
      queryString: payload,
      body: {}
    });
  },
  downloadLeadSample: payload =>
    apiCall('v1/partnerportal/csv/lead/sample', 'GET', {
      queryString: payload,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      }
    }),
  bulkLeadCreation: payload => {
    const { file, name } = payload;
    return apiCall('v1/partnerportal/csv/lead', 'POST', {
      body: {
        fileData: file,
        fileName: name
      }
    });
  },
  downloadCSVApiCall: payload => {
    const { fileName } = payload;
    return apiCall('v1/partnerportal/csv/lead', 'GET', {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
      queryString: {
        fileName
      }
    });
  },
  getCSVHistory: () => apiCall('v1/partnerportal/csv/lead/history', 'GET'),
  getRowIdResponse: payload =>
    apiCall('v1/partnerportal/csv/lead/row', 'GET', { queryString: payload }),
  downloadLeadFile: (payload) =>
    apiCall('v1/partnerportal/leads/download', 'GET', {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
      queryString: {
        ...payload
      }
    })
};
